import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * HomeRedirect Component
 * Redirects users to the appropriate home page based on their role
 * - field_agent -> /agent
 * - b2b/other roles -> Dashboard
 */
const HomeRedirect = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      if (user.role === 'field_agent') {
        navigate('/agent', { replace: true });
      } else {
        // For B2B customers and other roles, show dashboard
        navigate('/dashboard', { replace: true });
      }
    }
  }, [user, navigate]);

  // Show loading while redirecting
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
    </div>
  );
};

export default HomeRedirect;


